import getIsAppSearchEnabled from '../selectors/getIsAppSearchEnabled';
import { getCurrentModule } from 'owa-app-module-store';
import { Module } from 'owa-workloads-module';

export function shouldUseAppHostSearch(): boolean {
    return getIsAppSearchEnabled() && getCurrentModule() === Module.AppHost;
}
